<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h3>ABTOT</h3>
    </div>

    <div class="md-layout-item md-size-100">
      <div
        v-for="(data, area) in summary"
        :key="area"
        class="md-layout"
        id="abtot-row"
      >
        <div class="md-layout-item md-size-20">
          <h6>Value of {{ area.toUpperCase() }} Bookings</h6>
        </div>
        <div
          class="md-layout-item md-size-20"
          v-for="(info, idx) in data"
          :key="idx"
        >
          <report-financial-summary-abtot :data="info" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reportApi from "@/services/api/report";
import ReportFinancialSummaryAbtot from "@/pages/Reporting/ReportFinancialSummaryAbtot";

export default {
  data() {
    return {
      summary: {}
    };
  },

  props: {
    startDate: null,
    endDate: null
  },

  components: {
    ReportFinancialSummaryAbtot
  },

  methods: {
    getReportData() {
      reportApi
        .abtot({
          startDate: this.startDate,
          endDate: this.endDate
        })
        .then(response => {
          this.summary = response.data.reportData;
        });
    }
  },

  mounted() {
    this.getReportData();
  }
};
</script>
<style lang="scss" scoped>
#abtot-row {
  margin-bottom: 15px;
  border-bottom: 1px solid grey;

  h6 {
    margin-top: 0px;
  }
}
</style>
